import { Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

import { useNavigate } from "react-router-dom";

import theme from "../theme";
import { dateFormat, getFormattedDate } from "../util/dateFormat";

interface PhysicalVoucherProps {
  closeDrawer?: Function;
  openUpdate?: Function;
  voucher?: any;
}

const PhysicalVoucherDetails = (props: PhysicalVoucherProps) => {
  const navigate = useNavigate();

  const { closeDrawer, voucher } = props;

  const navigateToPhysicalVoucherScreen = () => {
    closeDrawer && closeDrawer(false);
    navigate("/uploadVoucher");
  };
  return (
    <Grid height={"100%"}>
      <Grid
        height={"15%"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        px={3}
      >
        <Typography
          sx={{
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: theme.font?.fontSize.large,
            fontWeight: theme.font?.fontWeight.thick,
          }}
          pl={2}
        >
          {voucher?.soldTo}
        </Typography>
        <IconButton
          aria-label="delete"
          onClick={
            closeDrawer ? () => navigateToPhysicalVoucherScreen() : () => {}
          }
        >
          <CloseIcon />
        </IconButton>
      </Grid>
      <Grid px={3}>
        <Grid
          display={"flex"}
          border={theme.border?.newGreyBorder}
          sx={{ background: theme.color?.newGreyBackground }}
          borderRadius={"16px"}
          px={3}
          flexDirection={"column"}
          py={4}
          gap={2}
        >
          <Grid
            height={"40%"}
            display={"flex"}
            justifyContent={"space-between"}
            gap={2}
            pb={2}
          >
            <Grid width={"50%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Physical Voucher ID
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                {voucher?.id || ""}
              </Typography>
            </Grid>
            <Grid width={"50%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Voucher No
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                {voucher?.voucherNo || ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid height={"40%"} display={"flex"} gap={2} pb={2}>
            <Grid width={"50%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Amount
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                {voucher?.amount || ""}
              </Typography>
            </Grid>
            <Grid width={"50%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Sold to
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                {voucher?.soldTo || ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid height={"40%"} display={"flex"} gap={2} pb={2}>
            <Grid width={"50%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Type
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                {voucher?.type || ""}
              </Typography>
            </Grid>
            <Grid width={"50%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Remarks
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                {voucher?.remarks || ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            height={"40%"}
            display={"flex"}
            gap={2}
            pb={2}
            borderBottom={theme.border?.smallGrey}
          >
            <Grid width={"50%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Issue Date
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                {voucher?.issueDate || ""}
              </Typography>
            </Grid>
            <Grid width={"45%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Expiry Date
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                {voucher?.expiryDate || ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid height={"95%"} display={"flex"} gap={2} pb={2}>
            <Grid width={"80%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Date Created
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                {voucher?.createdDate || ""}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PhysicalVoucherDetails;
